import React, { useEffect, useState } from "react";
import { DataConnectionCredentials, DataSourceProvider } from "common";
import {
  BucketObject,
  getParentDirectory,
} from "@via/pages/data/data-sources/utils/helpers.tsx";
import FileBrowserWrapper from "@via/pages/data/data-sources/cloud-data-sources/common/file-browser/file-browser-wrapper.tsx";
import { useUrlFolderList } from "@via/pages/data/data-sources/data-source.api.tsx";
import { useUrlDataConnection } from "@via/hooks/useUrlDataConnection.tsx";

export interface PathForm {
  path: string;
}

interface UrlFolderBrowserProps {
  onContinue: any;
  cart?: BucketObject[];
  setCart?: (cart: BucketObject[]) => void;
}

const UrlFolderBrowser: React.FC<UrlFolderBrowserProps> = ({
  onContinue,
  cart,
  setCart,
}) => {
  const { connectionCredentials, setConnectionCredentials } =
    useUrlDataConnection();

  const [folderList, setFolderList] = useState<any>();

  const {
    mutateAsync: getFolderList,
    data,
    isPending: isGetFolderListLoading,
    isSuccess: isGetFolderListSuccess,
  } = useUrlFolderList();

  useEffect(() => {
    if (isGetFolderListSuccess && data) {
      setFolderList(data);
    }
  }, [isGetFolderListSuccess, data]);

  useEffect(() => {
    if (connectionCredentials) {
      getFolderList(connectionCredentials);
    }
  }, [connectionCredentials]);

  const handlePathClick = async (payload: PathForm) => {
    if (payload.path) {
      const requestParams = Object.assign({}, connectionCredentials);
      requestParams.prefix = undefined;
      requestParams.bucketName = payload.path;

      await getFolderList(requestParams);
      setConnectionCredentials(requestParams);
    }
  };

  const handleObjectClick = async (object: BucketObject) => {
    const requestParams = Object.assign({}, connectionCredentials);
    if (object.id === "..") {
      requestParams.prefix = getParentDirectory(requestParams.prefix);
    } else {
      requestParams.prefix = object.name ? object.name : undefined;
    }

    await getFolderList(requestParams);
    setConnectionCredentials(requestParams);
  };

  const handleExtraFolderObjects = async () => {
    // do not request extra folder objects on url data source type
  };

  return (
    <FileBrowserWrapper
      connectionCredentials={connectionCredentials as DataConnectionCredentials}
      folderList={folderList}
      dataSourceProvider={DataSourceProvider.URL}
      onObjectClick={handleObjectClick}
      onPathChange={handlePathClick}
      getExtraFolderObjects={handleExtraFolderObjects}
      onContinue={onContinue}
      isGetFolderListLoading={isGetFolderListLoading}
      isGetExtraFolderListLoading={false}
      cart={cart}
      setCart={setCart}
    />
  );
};

export default UrlFolderBrowser;
